import SimpleCard from 'components/global/SimpleCard';
import UniversalInput from 'components/global/UniversalInput';
import { Button, Col, Image, Row } from 'react-bootstrap';
import { $form, $view } from 'signals/global.signals';
import { handleSignout } from 'components/global/_helpers/global.helpers';
import { handleSubmitOnboarding } from 'components/views/Onboarding/_helpers/onboarding.events';
import withDismount from 'hocs/withDismount';

const Onboarding = () => (
  <SimpleCard className="text-white bg-gray-800 px-40">
    <Row className="my-32 border-bottom border-gray-700 pb-16">
      <Col xs={12} className="text-center">
        <Image
          className="nav-logo mb-16"
          src="/images/logo-lg.png"
          height="100%"
        />
      </Col>
    </Row>
    <h4 className="text-center">Welcome to Dealsend!</h4>
    <p className="text-info text-center">Just need a little more information to get started.</p>
    <Row className="my-32 border-bottom border-gray-700 pb-32">
      <Col lg={12} className="mb-24">
        <UniversalInput
          label="I am here as"
          name="userType"
          type="select"
          value={$form.value.userType}
          options={[
            { label: 'Founder', value: 1 },
            { label: 'Investor', value: 2 },
          ]}
        />
      </Col>
      <Col lg={12} className="mb-24">
        <UniversalInput
          label="Company Name"
          name="companyName"
          value={$form.value.companyName}
        />
      </Col>
      <Col lg={6} className="mb-24">
        <UniversalInput
          label="First Name"
          name="firstName"
          value={$form.value.firstName}
        />
      </Col>
      <Col lg={6} className="mb-48">
        <UniversalInput
          label="Last Name"
          name="lastName"
          value={$form.value.lastName}
        />
      </Col>
      <Button
        onClick={handleSubmitOnboarding}
        disabled={!$form.value.firstName || !$form.value.lastName || !$form.value.companyName}
        variant="primary"
        className="w-100 py-8"
      >
        {$view.value.isLoading
          ? <div className="spinner-border" />
          : 'Complete'}
      </Button>
    </Row>
    <Row className="mb-32">
      <Col className="text-center">
        <div>Need to Start Over?</div>
        <Button
          className="btn-text text-primary bg-transparent border-0 p-0 mb-4 ms-4"
          onClick={handleSignout}
        >
          Sign Out
        </Button>
      </Col>
    </Row>
  </SimpleCard>
);

export default withDismount(Onboarding);
